module.exports = __webpack_public_path__ + "img/logo-scada.1bcdd057.png";